"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("./Body/Row"));

var _Header = _interopRequireDefault(require("./Header/Header"));

var _Footer = _interopRequireDefault(require("./Footer/Footer"));

var _ScrollableColumns = _interopRequireDefault(require("./Header/ScrollableColumns"));

var _Pagination = _interopRequireDefault(require("../Pagination"));

var _types = require("./utils/types");

var _utils = require("../../utils");

require("./Table.css");

var _useTableConfig2 = require("./hooks/useTableConfig");

var _utils2 = require("./utils/utils");

var _NoDataCell = _interopRequireDefault(require("./NoDataCell"));

var _TableMini = _interopRequireDefault(require("./TableMini"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Table = function Table(props) {
  var dataInit = props.data,
      mini = props.mini,
      footer = props.footer,
      scroll = props.scroll,
      noHeader = props.noHeader,
      className = props.className,
      noDataText = props.noDataText,
      orderColumns = props.orderColumns,
      onRow = props.onRow,
      headerControls = props.headerControls,
      onChange = props.onChange;
  var table = (0, _react.useRef)(null);
  var dataSource = (0, _react.useMemo)(function () {
    return (0, _utils2.setDataKeys)(dataInit);
  }, [dataInit]);

  var _useState = (0, _react.useState)(dataSource),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useTableConfig = (0, _useTableConfig2.useTableConfig)(_objectSpread(_objectSpread({}, props), {}, {
    table: table,
    dataSource: dataSource
  })),
      columns = _useTableConfig.columns,
      paging = _useTableConfig.paging,
      pagingTotal = _useTableConfig.pagingTotal,
      sorting = _useTableConfig.sorting,
      filtering = _useTableConfig.filtering,
      expandedRows = _useTableConfig.expandedRows,
      expandOnClick = _useTableConfig.expandOnClick,
      changeColumns = _useTableConfig.changeColumns,
      changeSorting = _useTableConfig.changeSorting,
      changeFiltering = _useTableConfig.changeFiltering,
      changePagination = _useTableConfig.changePagination,
      changePaginationTotal = _useTableConfig.changePaginationTotal,
      onMouseDown = _useTableConfig.onMouseDown;

  var scrollable = (0, _react.useMemo)(function () {
    return !!scroll;
  }, [scroll]);
  var classNameTable = (0, _utils.getClassNames)('Table', 'table', className, {
    scrollable: scrollable
  }, {
    'Table-mini': mini
  }, {
    'Table-no-header': noHeader
  }, {
    'Table-draggable': orderColumns
  }, {
    'Table-with-clickable-row': typeof onRow === 'function'
  });
  var classNameTableWrapper = (0, _utils.getClassNames)('Table-wrapper', 'table-wrapper', {
    scrollable: scrollable
  });
  var tableBodyStyle = (0, _react.useMemo)(function () {
    return scroll ? {
      maxHeight: scroll.y
    } : {};
  }, [scroll]);
  (0, _react.useEffect)(function () {
    var _getUpdatedSnapshot = (0, _utils2.getUpdatedSnapshot)({
      data: dataSource,
      columns: columns,
      sorting: sorting,
      filtering: filtering,
      paging: paging
    }),
        dataUpdated = _getUpdatedSnapshot.data,
        total = _getUpdatedSnapshot.total;

    setData(dataUpdated);
    if (paging.currentPage) changePaginationTotal(total);

    if (typeof onChange === 'function') {
      onChange(paging, filtering, sorting, {
        currentDataSource: dataSource
      });
    }
  }, [dataSource, sorting, filtering, paging]);

  if (mini) {
    return /*#__PURE__*/_react.default.createElement(_TableMini.default, {
      table: table,
      columns: columns,
      data: data,
      footer: footer,
      mini: mini,
      paging: paging,
      sorting: sorting,
      scrollable: scrollable,
      tableBodyStyle: tableBodyStyle,
      expandedRows: expandedRows,
      pagingTotal: pagingTotal,
      noDataText: noDataText,
      headerControls: headerControls,
      classNameTable: classNameTable,
      classNameTableWrapper: classNameTableWrapper,
      onRow: onRow,
      onMouseDown: onMouseDown,
      changeSorting: changeSorting,
      expandOnClick: expandOnClick,
      changePagination: changePagination
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: table,
    role: "presentation",
    className: classNameTableWrapper,
    onMouseDown: onMouseDown,
    onPointerDown: onMouseDown
  }, scrollable && /*#__PURE__*/_react.default.createElement("table", {
    className: classNameTable
  }, /*#__PURE__*/_react.default.createElement(_ScrollableColumns.default, {
    scrollable: scrollable,
    columns: columns
  }), /*#__PURE__*/_react.default.createElement(_Header.default, {
    columns: columns,
    sorting: sorting,
    filtering: filtering,
    changeColumns: changeColumns,
    changeSorting: changeSorting,
    headerControls: headerControls,
    changeFiltering: changeFiltering
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "Table-content",
    style: tableBodyStyle
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: classNameTable
  }, /*#__PURE__*/_react.default.createElement(_ScrollableColumns.default, {
    scrollable: scrollable,
    columns: columns
  }), !scrollable && /*#__PURE__*/_react.default.createElement(_Header.default, {
    columns: columns,
    sorting: sorting,
    filtering: filtering,
    changeColumns: changeColumns,
    changeSorting: changeSorting,
    headerControls: headerControls,
    changeFiltering: changeFiltering
  }), /*#__PURE__*/_react.default.createElement("tbody", null, data.length ? data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_Row.default, {
      data: item,
      index: index,
      columns: columns,
      scrollable: scrollable,
      expandedRows: expandedRows,
      onRow: (0, _utils2.onRowFunction)(onRow),
      expandOnClick: expandOnClick
    });
  }) : /*#__PURE__*/_react.default.createElement(_NoDataCell.default, {
    colSpan: columns.length,
    noDataText: noDataText
  })), !scrollable && /*#__PURE__*/_react.default.createElement(_Footer.default, {
    columns: columns,
    footer: footer
  }))), scrollable && /*#__PURE__*/_react.default.createElement("table", {
    className: classNameTable
  }, /*#__PURE__*/_react.default.createElement(_ScrollableColumns.default, {
    scrollable: scrollable,
    columns: columns
  }), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    columns: columns,
    footer: footer
  })), paging.currentPage && pagingTotal > data.length && /*#__PURE__*/_react.default.createElement(_Pagination.default, _extends({}, paging, {
    total: pagingTotal,
    onChange: changePagination
  })));
};

Table.propTypes = {
  /** Columns of table */
  columns: _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape, _propTypes.default.bool, _propTypes.default.func])))),

  /** Data record array to be displayed */
  data: _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape, _propTypes.default.func])))),

  /** Setting the default sorting for the column use
  * an object {key: string, direction: string } to define the
  * column key and 'asc' or 'desc' sort order */
  sorting: _types.sortState,
  filtering: _types.filteringState,
  noDataText: _propTypes.default.string,
  noHeader: _propTypes.default.bool,
  scroll: _propTypes.default.shape({
    y: _propTypes.default.number
  }),
  footer: _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]))),
  mini: _propTypes.default.bool,
  className: _propTypes.default.string,
  paging: _types.pagingState,
  orderColumns: _propTypes.default.bool,
  expandedColumn: _propTypes.default.string,
  expandedRowKeys: _propTypes.default.arrayOf(_propTypes.default.string),
  defaultExpandAllRows: _propTypes.default.bool,
  rowSelection: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['radio', 'checkbox']),
    selectedRowKeys: _propTypes.default.arrayOf(_propTypes.default.string),
    onChange: _propTypes.default.func
  }),
  onRow: _propTypes.default.func,
  onChange: _propTypes.default.func,
  handleSort: _propTypes.default.func,
  headerControls: _propTypes.default.shape({
    selectControlsLabel: _propTypes.default.shape({
      selectAll: _propTypes.default.string,
      reset: _propTypes.default.string
    }),
    sortByLabel: _propTypes.default.string
  })
};
Table.defaultProps = {
  columns: [],
  data: [],
  sorting: null,
  filtering: null,
  noDataText: 'No data',
  noHeader: false,
  scroll: null,
  footer: null,
  mini: false,
  className: '',
  paging: null,
  onRow: null,
  orderColumns: false,
  expandedColumn: null,
  expandedRowKeys: [],
  defaultExpandAllRows: false,
  rowSelection: null,
  onChange: function onChange() {},
  handleSort: function handleSort() {},
  headerControls: {
    selectControlsLabel: {
      selectAll: 'Select all',
      reset: 'Reset'
    },
    sortByLabel: 'By:'
  }
};
var _default = Table;
exports.default = _default;